export const DATA_ANALYST_ROLE_PROMO_FF = 'call-intelligence:enable-data-analyst-role-promo';
export const DATA_ANALYST_CAMPAIGN_END_FF = 'call-intelligence:data-analyst-promo-campaign-end';
export const DATA_ANALYST_ROLE_HELP_LINK = 'https://www.weavehelp.com/weavehelp/article/see-your-user-role';
export const DATA_ANALYST_PROMO_MAX_DISPLAY_DAYS = 7;
export const DATA_ANALYST_ROLE_NAME = 'Data Analyst';

// TODO: Update these links when the articles are live
export const TSS_OVERVIEW_HELP_LINK = 'https://www.weavehelp.com/weavehelp/article/call-intelligence';
export const TSS_UNSCHEDULED_HELP_LINK = 'https://www.weavehelp.com/weavehelp/article/call-intelligence';
export const TSS_RECOVERED_OPPORTUNITY_HELP_LINK = 'https://www.weavehelp.com/weavehelp/article/call-intelligence';

export const TSS_IN_APP_BANNER_FF = 'call-intel:in-app-banner:tss:enable';
export const TSS_IN_APP_BANNER_BETA_VARIANT_FF = 'call-intel:in-app-banner:tss:beta-variant';
